import { Icon } from '@volvo-cars/react-icons';
import dynamic from 'next/dynamic';
import { ReactElement } from 'react';
import { ExtendCSS, Flex, Spacer, Text } from 'vcc-ui';

const Warning = dynamic(() => import('icons/Warning'));

type Severity = 'info' | 'warning';
type BlockVariant = { icon: ReactElement; borderColor: string };

const NotificationBlock: React.FC<{
  severity?: Severity;
  children: string | ReactElement;
}> = ({ severity = 'info', children }) => (
  <Flex extend={wrapperStyle(severity)}>
    <Flex extend={{ flexShrink: 0 }}>{variants[severity].icon}</Flex>
    <Spacer size={1.5} />
    <Text fg="foreground.secondary">{children}</Text>
  </Flex>
);

const variants: Record<Severity, BlockVariant> = {
  warning: {
    icon: <Warning />,
    borderColor: 'rgba(235, 116, 0, 0.3)',
  },
  info: {
    icon: <Icon icon="info-circled" size={24} color="secondary" />,
    borderColor: 'ornament.border',
  },
};

const wrapperStyle =
  (severity: Severity): ExtendCSS =>
  ({ theme: { baselineGrid } }) => ({
    flexDirection: 'row',
    padding: baselineGrid * 2,
    margin: `${baselineGrid * 4}px 0`,
    border: '1px solid',
    borderColor: variants[severity].borderColor,
    borderLeftWidth: 3,
  });

export default NotificationBlock;
